export type SessionType = "Desktop" | "Mobile";

export type AgentState = "Idle" | "Break" | "PendingBreak" | "Busy" | "LoggedOut" | "PendingLogout";

// valid until only voice tasks are handled in this app
export function isOnCall(state: AgentState): boolean {
  return state === "Busy" || state === "PendingBreak" || state === "PendingLogout";
}

export interface AgentStateDto {
  id: string;
  state: AgentState;
  stateSince: Date;
  breakName: string | null;
  timedBreakExpiresAt: Date | null;
  sessionType: SessionType | null;
  allowBusinessUnitSelection: boolean;
}
